<script lang="ts">
  export let addMargin: boolean = true;
</script>

<div class:content={addMargin} data-testid="loading">
  <div class="spinner-border" role="status" />
</div>

<style>
  .content {
    display: flex;
    justify-content: center;
    margin: 5rem 0;
  }
</style>
